<h2 mat-dialog-title class="text text-bold px-1">
  {{ "alert.confirm" | translate }}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="closeDialog()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>

<mat-divider></mat-divider>
<mat-dialog-content>
  <div class="row px-5 mt-3" style="overflow-y: hidden;">
    <p [innerHTML]="getContent()"></p>  
    <p *ngIf="duration != -1" [innerHTML]="getDuration()"></p> 
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button nz-button nzType="default" class="mr-3 btn-back" (click)="closeDialog()" type="button">
    {{'button.cancel' | translate}}
  </button>
  <button type="button"
    (click)="onClickBtn()" nz-button nzType="danger">
    {{'button.confirm' | translate}}
  </button>
</mat-dialog-actions>
